import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { reportsBreadcrumbsHistory } from './functions';

const ReportsBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="report-breadcrumbs"
      history={reportsBreadcrumbsHistory(t, location)}
    />
  );
};

export default ReportsBreadcrumbs;
